<script lang="ts">
  import { Button } from "$lib/components/ui/button";
  import * as Dialog from "$lib/components/ui/dialog/index.js";
  import { t } from "svelte-i18n";
  import { ScrollArea } from "$lib/components/ui/scroll-area/index.js";
  import PaymentScheduleTable from "../amounts/payment-schedule-table.svelte";
  import * as Card from "$lib/components/ui/card/index.js";
  import {
    hasProjectFormSectionErrors,
    projectDraft,
    ProjectFormSection,
  } from "$src/application/projects/stores/projectStore";
  import TotalAmountsTable from "../amounts/total-amounts-table.svelte";
  
  export let groupStoreId: number;
  export let open: boolean = false;
  export let onConfirmOrder: () => void;

  let isConfirmed: boolean = false;


  function onOpenChange(open: boolean) {

    if (!open) {
      if (!isConfirmed) {
        $projectDraft.schedule = { payments: [] };
      }
    }
  }

  function confirmOrder() {
    if (hasProjectFormSectionErrors(ProjectFormSection.Amounts) == false) {
      isConfirmed = true;
      open = false;
      onConfirmOrder();
    }
  }
</script>

<Dialog.Root bind:open={open} onOpenChange={onOpenChange}>
  <Dialog.Content
    class="flex flex-col h-dvh sm:h-[650px] sm:my-auto overflow-hidden sm:max-h-dvh max-w-4xl"
  >
    <Dialog.Header>
      <Dialog.Title>{$t("page.projects.detail.order.title")}</Dialog.Title>
    </Dialog.Header>
    <div class="flex flex-col flex-grow h-full overflow-hidden">
      <ScrollArea orientation="vertical">
        <div class="flex flex-wrap w-full h-full gap-2">
          <Card.Root>
            <Card.Header id="priceTable" class="pb-1">
              <Card.Title>
                {$t("page.projects.detail.schedule.title")}
              </Card.Title>
            </Card.Header>
            <Card.Content class="flex flex-row justify-around flex-wrap gap-4">
              <PaymentScheduleTable displayTitle={false} groupStoreId={groupStoreId} />
            </Card.Content>
          </Card.Root>
          <TotalAmountsTable />
        </div>
      </ScrollArea>
    </div>
    <Dialog.Footer class="flex pt-0">
      <Button type="submit" class="px-8" on:click={confirmOrder}>
        {$t("page.projects.detail.order.ok")}
      </Button>
    </Dialog.Footer>
  </Dialog.Content>
</Dialog.Root>
